/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCaseOpeningAccountDto,
  ApiEnvelopeCaseOpeningEmptyResponse,
  ApiEnvelopeCaseOpeningTaskResponse,
  OpenCasesRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type caseOpeningGetCaseOpeningAccountResponse200 = {
  data: ApiEnvelopeCaseOpeningAccountDto
  status: 200
}

export type caseOpeningGetCaseOpeningAccountResponse404 = {
  data: ApiEnvelopeCaseOpeningAccountDto
  status: 404
}

export type caseOpeningGetCaseOpeningAccountResponseSuccess = (caseOpeningGetCaseOpeningAccountResponse200) & {
  headers: Headers;
};
export type caseOpeningGetCaseOpeningAccountResponseError = (caseOpeningGetCaseOpeningAccountResponse404) & {
  headers: Headers;
};

export type caseOpeningGetCaseOpeningAccountResponse = (caseOpeningGetCaseOpeningAccountResponseSuccess | caseOpeningGetCaseOpeningAccountResponseError)

export const getCaseOpeningGetCaseOpeningAccountUrl = (botId: string,) => {




  return `/api/caseopening/${botId}`
}

export const useCaseOpeningGetCaseOpeningAccountHook = (): (botId: string, options?: RequestInit) => Promise<caseOpeningGetCaseOpeningAccountResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getCaseOpeningGetCaseOpeningAccountUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type caseOpeningScanCasesResponse200 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 200
}

export type caseOpeningScanCasesResponse400 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 400
}

export type caseOpeningScanCasesResponse404 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 404
}

export type caseOpeningScanCasesResponseSuccess = (caseOpeningScanCasesResponse200) & {
  headers: Headers;
};
export type caseOpeningScanCasesResponseError = (caseOpeningScanCasesResponse400 | caseOpeningScanCasesResponse404) & {
  headers: Headers;
};

export type caseOpeningScanCasesResponse = (caseOpeningScanCasesResponseSuccess | caseOpeningScanCasesResponseError)

export const getCaseOpeningScanCasesUrl = (botId: string,) => {




  return `/api/caseopening/${botId}/scan`
}

export const useCaseOpeningScanCasesHook = (): (botId: string, options?: RequestInit) => Promise<caseOpeningScanCasesResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getCaseOpeningScanCasesUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type caseOpeningOpenCasesResponse200 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 200
}

export type caseOpeningOpenCasesResponse400 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 400
}

export type caseOpeningOpenCasesResponse404 = {
  data: ApiEnvelopeCaseOpeningTaskResponse
  status: 404
}

export type caseOpeningOpenCasesResponseSuccess = (caseOpeningOpenCasesResponse200) & {
  headers: Headers;
};
export type caseOpeningOpenCasesResponseError = (caseOpeningOpenCasesResponse400 | caseOpeningOpenCasesResponse404) & {
  headers: Headers;
};

export type caseOpeningOpenCasesResponse = (caseOpeningOpenCasesResponseSuccess | caseOpeningOpenCasesResponseError)

export const getCaseOpeningOpenCasesUrl = (botId: string,) => {




  return `/api/caseopening/${botId}/open`
}

export const useCaseOpeningOpenCasesHook = (): (botId: string,
    openCasesRequest?: OpenCasesRequest, options?: RequestInit) => Promise<caseOpeningOpenCasesResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    openCasesRequest?: OpenCasesRequest, options?: RequestInit) => {

        return customFetcher(getCaseOpeningOpenCasesUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(openCasesRequest)
  }
);
      }
  }


export type caseOpeningStopCaseOpeningResponse200 = {
  data: ApiEnvelopeCaseOpeningEmptyResponse
  status: 200
}

export type caseOpeningStopCaseOpeningResponse404 = {
  data: ApiEnvelopeCaseOpeningEmptyResponse
  status: 404
}

export type caseOpeningStopCaseOpeningResponseSuccess = (caseOpeningStopCaseOpeningResponse200) & {
  headers: Headers;
};
export type caseOpeningStopCaseOpeningResponseError = (caseOpeningStopCaseOpeningResponse404) & {
  headers: Headers;
};

export type caseOpeningStopCaseOpeningResponse = (caseOpeningStopCaseOpeningResponseSuccess | caseOpeningStopCaseOpeningResponseError)

export const getCaseOpeningStopCaseOpeningUrl = (botId: string,) => {




  return `/api/caseopening/${botId}/stop`
}

export const useCaseOpeningStopCaseOpeningHook = (): (botId: string, options?: RequestInit) => Promise<caseOpeningStopCaseOpeningResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getCaseOpeningStopCaseOpeningUrl(botId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


